import { useEffect, useState } from "react";
import { adminListBookings } from "@/lib/api";

export default function Bookings() {
  const [data, setData] = useState({ service_bookings: [], test_rides: [] });
  const [tab, setTab] = useState("service");

  useEffect(() => {
    adminListBookings().then(setData).catch(() => {});
  }, []);

  return (
    <div data-testid="bookings-page" className="space-y-8">
      <div>
        <p className="text-overline mb-3">Εισερχόμενα</p>
        <h1 className="font-display font-black uppercase text-4xl tracking-tight">Κρατήσεις & δοκιμές</h1>
      </div>

      <div className="flex gap-2 border-b border-white/10">
        {[
          { key: "service", label: `Σέρβις (${data.service_bookings.length})` },
          { key: "ride", label: `Δοκιμές (${data.test_rides.length})` },
        ].map((t) => (
          <button
            key={t.key}
            data-testid={`bookings-tab-${t.key}`}
            onClick={() => setTab(t.key)}
            className={`px-5 py-3 text-xs font-bold uppercase tracking-wider transition-colors ${
              tab === t.key ? "text-[#E50000] border-b-2 border-[#E50000]" : "text-white/60 hover:text-white"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "service" ? (
        <Table
          rows={data.service_bookings}
          columns={[
            { k: "full_name", label: "Όνομα" },
            { k: "email", label: "Email" },
            { k: "phone", label: "Τηλέφωνο" },
            { k: "bike_brand", label: "Μάρκα" },
            { k: "bike_model", label: "Μοντέλο" },
            { k: "bike_year", label: "Έτος" },
            { k: "service_type", label: "Τύπος" },
            { k: "preferred_date", label: "Ημερομηνία" },
            { k: "notes", label: "Σημειώσεις" },
          ]}
        />
      ) : (
        <Table
          rows={data.test_rides}
          columns={[
            { k: "full_name", label: "Όνομα" },
            { k: "email", label: "Email" },
            { k: "phone", label: "Τηλέφωνο" },
            { k: "bike_label", label: "Μηχανή" },
            { k: "preferred_date", label: "Ημερομηνία" },
            { k: "license_years", label: "Δίπλωμα (έτη)" },
            { k: "notes", label: "Σημειώσεις" },
          ]}
        />
      )}
    </div>
  );
}

function Table({ rows, columns }) {
  if (!rows.length) {
    return <div className="border border-white/10 p-10 text-white/50">Καμία εγγραφή ακόμα.</div>;
  }
  return (
    <div className="border border-white/10 overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-[#141414]">
          <tr className="text-left text-overline">
            {columns.map((c) => <th key={c.k} className="p-3 whitespace-nowrap">{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className="border-t border-white/5">
              {columns.map((c) => (
                <td key={c.k} className="p-3 whitespace-nowrap text-white/80">{String(r[c.k] ?? "")}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
